import { render, staticRenderFns } from "./viewsidelist.vue?vue&type=template&id=09007278&"
import script from "./viewsidelist.vue?vue&type=script&lang=js&"
export * from "./viewsidelist.vue?vue&type=script&lang=js&"
import style0 from "./viewsidelist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports